import React, { useState } from 'react';
import { Images, useBaseModal } from 'utils';
import { EditWithIcon, SimpleTabs } from 'components';
import { BaselineMastery } from 'fragments/client/clientSingle/clientClinical/goals/baseline/baselineMastery';
import { BaselineMaintenance } from 'fragments/client/clientSingle/clientClinical/goals/baseline/baselineMaintenance';

const targetDetailsLibraryGoalDetailsLabels = [{ label: 'Progress Rules' }];

export const LibraryTargetDetails = ({ target }) => {
    const [tab, setTab] = useState('Progress Rules');
    const { closeBase } = useBaseModal();

    const tabsContent = [
        {
            tabComponent: (
                <div className="full-width">
                    <BaselineMastery target={target} isLibrary />
                    <BaselineMaintenance selectedTarget={target} isLibrary />
                </div>
            ),
            tab: 'Progress Rules',
        },
    ];

    return (
        <div style={{ width: 1400, maxWidth: '100%' }}>
            <div className="flex-align-center" style={{ gap: 8 }}>
                <EditWithIcon icon={Images.backArrow} type={'button'} handleClick={closeBase} />
                <p className="modal-header-title">{target?.name}</p>
            </div>
            <SimpleTabs
                tab={tab}
                getTab={setTab}
                defaultTab={tab}
                tabsLabels={targetDetailsLibraryGoalDetailsLabels}
                tabsContent={tabsContent}
            />
        </div>
    );
};
